import { useTestStore } from '@/store/useTestStore';
import { LargeListTest, CssAnimTest, ComputeTest, MemoryTest, Canvas2DTest, WebGLTest, EventsTest, NetworkTest } from '@/tests/tv';

const TV_TEST_MAP: Record<string, React.FC<{ autoRun: boolean; autoNonce: number }>> = {
  'tv-list': LargeListTest,
  'tv-css': CssAnimTest,
  'tv-compute': ComputeTest,
  'tv-memory': MemoryTest,
  'tv-canvas2d': Canvas2DTest,
  'tv-webgl': WebGLTest,
  'tv-events': EventsTest,
  'tv-network': NetworkTest,
};

export function TvTestSuite() {
  const { activeView, autoRunning, autoNonce, getRunOrder } = useTestStore();
  const order = getRunOrder();
  const activeAutoTestId = autoRunning ? order[useTestStore.getState().autoIdx] : null;

  const Component = TV_TEST_MAP[activeView];
  if (!Component) return null;

  return (
    <Component
      autoRun={activeAutoTestId === activeView}
      autoNonce={autoNonce}
    />
  );
}
